import { queryClient } from "@lib/queryClient";

import type { ProviderItem, ProviderType } from "./providers";
import { getProvider } from "./providers";
import type { FindEndpoint, SearchEndpoint } from "./types";

export function getFindEndpoint<T extends ProviderType>(type: T): FindEndpoint<T> {
  return `/remote_lookup/:app_group_id/${type}/find`;
}

export function getSearchEndpoint<T extends ProviderType>(type: T): SearchEndpoint<T> {
  return `/remote_lookup/:app_group_id/${type}/search`;
}

/**
 * Returns a function that can be used to add items to the cache for a given
 * provider type.
 */
export function createAddItemsToCache<T extends ProviderType>(type: T) {
  const provider = getProvider(type);
  const findEndpoint = getFindEndpoint(type);
  const addItemsToCache = (appGroupId: string, items: ProviderItem<T>[]) => {
    for (const item of items) {
      const queryKey = [
        { cacheKey: findEndpoint, appGroupId },
        { id: provider.mapItemToId(item), app_group_id: appGroupId },
      ];
      queryClient.setQueryData(queryKey, { item });
    }
  };
  return addItemsToCache;
}
